import React, { Component } from "react";
import { alertActions } from '../../action/AlertAction';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { accountActions } from "../../action/AccountAction";
import { commonClass } from "../../helpers/commonClass";
import { Helmet } from "react-helmet";
// import countrycode from '../Home/countrycode.json';

class KycStatus extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Pending: 1,
            Success: 2
        };
    }
    static getDerivedStateFromProps(props, state) {
        return { details: props.details }
    }


    render() {
        const { t } = this.props;
        return (
            <>
                {process.env.REACT_APP_MODE != "development" && <Helmet>
                    <title>Gulf Ticket : Profile</title>
                    <meta name="description" content="Gulf Ticket Profile" />
                </Helmet>
                }
                {/*0 == Kyc Need to verify (initial state)
1 == success
2 == pending
3 == reject */}
                <div class="myAccContHead">
                    <h1><img src="./assets/img/icons/tabs-profile.png" />{t('lblProfile')}</h1>
                    <div class="proChangePass" onClick={() => { this.props.kyccontrolfunc(2) }}><img src="./assets/img/icons/lock-y.png" />{t('lblChangepPwd')}</div>
                </div>
                <div class="myAccContInfo">
                    <div class="myAccContInfoCont">
                        <h2>{t('lblkycstatus')}</h2>
                        <div class="myAccContInfoLft">
                            <img src={this.props.user.kycstatus == 0 ? "./assets/img/icons/need-to-verify.png"
                                : this.props.user.kycstatus == 1 ? "./assets/img/icons/verified-g.png"
                                    : this.props.user.kycstatus == 2 ? "./assets/img/icons/pending.png"
                                        : "./assets/img/icons/rejected.png"
                            } />
                        </div>
                        <div class="myAccContInfoRht">
                            <h3>{this.props.user.kycstatus == 0 ? `${t('lblkycneed')}`
                                : this.props.user.kycstatus == 1 ?
                                    `${t('lblverified')}`
                                    : this.props.user.kycstatus == 2 ? `${t('lblpending')}`
                                        : `${t('lblreject')}`}</h3>

                            <p>{this.props.user.kycstatus == 0 ? `${t('lblkycneedtext')}`
                                : this.props.user.kycstatus == 1 ?
                                    `${t('lblkycverified')}`
                                    : this.props.user.kycstatus == 2 ? `${t('lblkycincom')}`
                                        : `${t('lblrejecttext')}`}</p>
                            {(this.props.user.kycstatus == 0 || this.props.user.kycstatus == 3) && <a onClick={() => { this.props.kyccontrolfunc(1) }}>
                                {this.props.user.kycstatus == 0 ? `${t('lblkyccomplete')}`
                                    : `${t('lblviewdetails')}`}</a>}
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
function mapStateToProps(state) {
    const { user, appvariables } = state.loginReducer;
    const { details } = state.accountReducer;
    return { user, details, appvariables };
}
const mapActionToProps = {
    alertError: alertActions.error,
}
export default connect(mapStateToProps, mapActionToProps)(withTranslation()(KycStatus))